module.exports = __webpack_public_path__ + "static/img/wls.ed508574.png";